import "./styling/SerieDetailsPage.css"

import DetailListItem from "../Components/DetailListItem/DetailListItem"
import ContentDetails from "../Components/ContentDetails/ContentDetails"
import CenteredMessage from "../Components/CenteredMessage/CenteredMessage"
import { NavigationBar } from "../Components/NavigationBar/NavigationBar"
import TemplateModal from "../Components/TemplateModal/TemplateModal"

import { useState } from "react"
import { useParams, useNavigate } from "react-router-dom"
import { useContentDetails } from "../hooks/useContentDetails"
import { LoadingMessage } from "../Components/ModalMessage/LoadingMessage";

export const SerieDetailsPage = () => {
    const { id } = useParams()
    const navigate = useNavigate()
    const { headerContent, episodes, loading, error } = useContentDetails({ serieId: id })
    const [showTemplateModal, setShowTemplateModal] = useState(false);
    const [selectedContent, setSelectedContent] = useState(null);

    if (loading) return <LoadingMessage />
    if (error) return <CenteredMessage message={error} />
    if (!headerContent) return <CenteredMessage message={"Série não encontrada"} />
    if (!episodes || episodes.length === 0) return <CenteredMessage message={"Nenhum episódio disponível"} />

    const handleHeaderClick = () => {
        const availableContents = episodes.filter(content => content.status === 'available');
        if (availableContents.length > 0) {
            const firstEp = availableContents[0];
            navigate(`/video/${firstEp.contentId}`, {
                state: {
                    playlist: availableContents,
                    from: `/serie_details/${id}`
                }
            });
        } else {
            setSelectedContent(headerContent);
            setShowTemplateModal(true);
        }
    }

    const handleItemClick = (content) => {
        if (!content) return;

        if (content.status === 'available') {
            const availableContents = episodes.filter(ep => ep.status === 'available');
            navigate(`/video/${content.contentId}`, {
                state: {
                    playlist: availableContents,
                    from: `/serie_details/${id}`
                }
            });
        } else {
            setSelectedContent(content);
            setShowTemplateModal(true);
        }
    }

    const handleTemplateModalClose = () => {
        setShowTemplateModal(false);
        setSelectedContent(null);
    };

    return (
        <div className="serie-details-container">
            <NavigationBar
                onBackClick={() => navigate("/")}
                title={headerContent.title}
            />

            <ContentDetails
                thumbnailUrl={headerContent.thumbnailUrl}
                title={headerContent.title}
                description={headerContent.description}
                onClick={handleHeaderClick}
            />

            <div className="serie-details-episodes-container">
                {episodes.map((ep) => (
                    <DetailListItem
                        key={ep.contentId}
                        title={ep.title}
                        description={ep.description}
                        thumbnail={ep.thumbnailUrl}
                        status={ep.status}
                        onClick={() => handleItemClick(ep)}
                    />
                ))}
            </div>

            {showTemplateModal && selectedContent && (
                console.log(selectedContent),
                <TemplateModal
                    templateId={selectedContent.salesPage}
                    onClose={handleTemplateModalClose}
                />
            )}
        </div>
    )
}
